import { getAmplitudeInstance } from '../amplitudeHelpers';
import ListItemType from '../enums/ListItemType';
import MapType from '../enums/MapType';

type logSaveListSelectedParams = {
  list_id: number;
  list_type: ListItemType;
  map_id: number;
  map_type: MapType;
};

/**
 * A user selects a list after clicking the save icon. This includes 'my favorites' and will result in an item being saved to that list.
 * @param params - Attributes to log with the amplitude event
 * @param params.list_id - The id of the selected list (built-in list for favorites, custom list for others).
 * @param params.list_type - The type of list selected
 * @param params.map_id - The id of the map being saved (could be trail/activity/etc)
 * @param params.map_type - The type of map saved to a list.
 */
const logSaveListSelected = ({ list_id, list_type, map_id, map_type }: logSaveListSelectedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'save list selected',
    { 'list id': list_id, 'list type': list_type, 'map id': map_id, 'map type': map_type },
    callback
  );
};

export default logSaveListSelected;
